import React, {createRef, useEffect, useState} from "react"
import styles from "../../../../styles/contract.module.css"
import {useScreenshot} from "use-react-screenshot";
import {DebounceInput} from "react-debounce-input";
import {nanoid} from "nanoid";

const TextAsSignature = ({onTextWritten,textRefCallback}) => {
    const ref = createRef();
    const [_, takeScreenShot] = useScreenshot({
        type: "image/jpeg",
        quality: 1.0
    });
    const [text,setText] = useState("")


    const download = async (image, { name = "img", extension = "jpg" } = {}) => {

        const blob = await fetch(image).then((res) => res.blob());
        let metadata = {
            type: 'image/jpeg'
        };
        console.log(image,"1")
        onTextWritten(new File([blob], `${nanoid()}.jpeg`, metadata))
    };

    const downloadScreenshot = () => {
        // isTextLoading(true)
        takeScreenShot(ref.current).then(download)
        // isTextLoading(false)
    }

    useEffect(()=>{
        // downloadScreenshot()
    },[text])

    return(
        <>
            <div className={styles.text__wrapper}>
                <div className={styles.text__input}>
                    {/*<DebounceInput*/}
                    {/*    minLength={2}*/}
                    {/*    debounceTimeout={300}*/}
                    {/*    onChange={event => setText(event.target.value)} />*/}
                    <input type={"text"} onChange={event => setText(event.target.value)} value={text} autoFocus={true} maxLength={20}/>
                    <div ref={textRefCallback} className={styles.span__wrapper}>
                        <span className={!text ? styles.no__text : ""}>{text ? text : "..."}</span>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TextAsSignature
